import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import styled from '@emotion/styled';
import { css, SerializedStyles } from '@emotion/react';
import { withConfig } from 'src/withConfig';
import { FiltersSkin, FiltersSkinType } from 'src/domains/layouts/webview/components/filters/FiltersSkin';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';

const setBorders = (theme: EmotionTheme, isActive: boolean, isFinished: boolean, skin?: FiltersSkinType): SerializedStyles => {
    if (skin === FiltersSkin.PRIMARY) {
        if (isActive === true) {
            return css`
                border: 1px solid ${theme.star.filtersColors.primary.borderColor};
            `;
        }
        if (isFinished === true) {
            return css`
                border: 1px solid ${theme.star.raceCard.filters.time.borderColor};
            `;
        }
        return css`
            border: 1px solid ${theme.star.filtersColors.primary.borderColorSecondary};
        `;
    }

    if (skin === FiltersSkin.SECONDARY) {
        if (isActive === true) {
            return css`
                border: 1px solid ${theme.star.filtersColors.secondary.borderColor};
            `;
        }
        if (isFinished === true) {
            return css`
                border: 1px solid ${theme.star.raceCard.filters.time.borderColor};
            `;
        }
        return css`
            border: 1px solid ${theme.star.filtersColors.secondary.borderColorSecondary};
        `;
    }

    if (skin === FiltersSkin.TERTIARY) {
        if (isActive === true) {
            return css`
                border: 1px solid ${theme.star.filtersColors.tertiary.borderColor};
            `;
        }
        if (isFinished === true) {
            return css`
                border: 1px solid ${theme.star.raceCard.filters.time.borderColor};
            `;
        }
        return css`
            border: 1px solid ${theme.star.filtersColors.tertiary.borderColorSecondary};
        `;
    }

    return css``;
};

const setColors = (theme: EmotionTheme, isActive: boolean, isFinished: boolean, skin?: FiltersSkinType): SerializedStyles => {
    if (skin === FiltersSkin.PRIMARY) {
        if (isActive === true) {
            return css`
                background: ${theme.star.filtersColors.primary.bgColor};
                color: ${theme.star.filtersColors.primary.txtColorSecondary};
            `;
        }
        if (isFinished === true) {
            return css`
                background: ${theme.star.raceCard.filters.time.bgColorSecondary};
                color: ${theme.star.raceCard.filters.time.txtColorSecondary};
            `;
        }
        return css`
            background: ${theme.star.filtersColors.primary.bgColorSecondary};
            color: ${theme.star.filtersColors.primary.txtColor};
        `;
    }

    if (skin === FiltersSkin.SECONDARY) {
        if (isActive === true) {
            return css`
                background: ${theme.star.filtersColors.secondary.bgColor};
                color: ${theme.star.filtersColors.secondary.txtColorSecondary};
            `;
        }
        if (isFinished === true) {
            return css`
                background: ${theme.star.raceCard.filters.time.bgColorSecondary};
                color: ${theme.star.raceCard.filters.time.txtColorSecondary};
            `;
        }
        return css`
            background: ${theme.star.filtersColors.secondary.bgColorSecondary};
            color: ${theme.star.filtersColors.secondary.txtColor};
        `;
    }

    if (skin === FiltersSkin.TERTIARY) {
        if (isActive === true) {
            return css`
                background: ${theme.star.filtersColors.tertiary.bgColor};
                color: ${theme.star.filtersColors.tertiary.txtColorSecondary};
            `;
        }
        if (isFinished === true) {
            return css`
                background: ${theme.star.raceCard.filters.time.bgColorSecondary};
                color: ${theme.star.raceCard.filters.time.txtColorSecondary};
            `;
        }
        return css`
            background: ${theme.star.filtersColors.tertiary.bgColorSecondary};
            color: ${theme.star.filtersColors.tertiary.txtColor};
        `;
    }

    return css`
        color: red;
        background-color: blue;
    `;
};

interface FilterItemStyledPropsType {
    isActive: boolean;
    isFinished: boolean;
    skin?: FiltersSkinType;
    variant: DefaultComponentVariantType | null;
}

export const FilterItem = withConfig(theme => styled('button', { label: 'FilterItem' })<FilterItemStyledPropsType>`
    ${({ isActive, isFinished, skin }): SerializedStyles => setBorders(theme, isActive, isFinished, skin)}
    ${({ isActive, isFinished, skin }): SerializedStyles => setColors(theme, isActive, isFinished, skin)}
    align-items: center;
    border-radius: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? theme.star.radius.small : '0'};
    cursor: pointer;
    display: flex;
    flex-flow: row nowrap;
    flex: 0 0 62px;
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.bold};
    gap: 4px;
    height: 32px;
    justify-content: center;
    line-height: 1.3334;
    margin-right: 4px;
    padding: 8px 12px;
    text-transform: capitalize;
    white-space: nowrap;
    &:last-of-type {
        margin-right: 0;
    }
`);
